import React from 'react'
import FormROValue from '../../../../../library/form/components/FormROValue1';
import FormAttachment from '../../../../../library/form/components/FormAttachment';
import FormLink from '../../../../../library/form/components/FormLink';
import SarasGridContainer from '../../../../../library/container/grid/SarasGridContainer';
import SarasGridItem from '../../../../../library/container/grid/SarasGridItem';
import SarasTrans from '../../../../../library/notifications/SarasTrans';

const ProdSearchGridHeader = ({formObject, viewData, rowKey}) => {

    return (
        <FormLink className="uiLinkRow" formObject={formObject} rowKey={rowKey} linkProp={{ target: "_blank" }}
            action={{ paramName: "docID", actionId: "show", actionName: "prodComp" }}>
            <div className="saras-cell" style={{height:"154px"}}>
                <SarasGridContainer spacing={1} direction="row">
                    <SarasGridItem xs={6} sm={6}>
                        <div style={{width:"50px", height: "50px"}}>
                            <FormAttachment imgStyle={{width:"50px", height:"50px"}} formObject={formObject} rowKey={rowKey} action={{ InputType: "i", paramName: "targetItemImage" }} />
                        </div>
                    </SarasGridItem>
                    <SarasGridItem xs={6} sm={6}>
                        <div>
                            <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "docID" }} className='uiHighlightKey' />
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <span className="uiBold"><SarasTrans value="Status" /></span>
                            <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "status" }} className="uiGridText" />
                        </div>
                    </SarasGridItem>
                    <SarasGridItem xs={6} sm={6}>
                        <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "targetItemId" }} className=''/>
                    </SarasGridItem>
                    <SarasGridItem xs={6} sm={6}>
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <span className="uiBold"><SarasTrans value="O/P Plan" /></span>
                            <FormROValue tooltip="Plan finish date" formObject={formObject} rowKey={rowKey} action={{ paramName: "finishDate" }} className=""/>
                        </div>
                    </SarasGridItem>
                    <SarasGridItem xs={6} sm={6}>
                        <FormROValue formObject={formObject} rowKey={rowKey} action={{ paramName: "targetItemType1" }} className="uiUnHighlight"/>
                        <FormROValue formObject={formObject} rowKey={rowKey} action={{ paramName: "targetItemType2" }} className="uiUnHighlight uiSpacerL5"/>
                    </SarasGridItem>
                    <SarasGridItem xs={6} sm={6}>
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "qty" }} className='uiHighlightKey uiBlue' />
                            <FormROValue className="uiPriority" formObject={formObject} rowKey={rowKey} action={{ paramName: "priority" }} />
                        </div>
                    </SarasGridItem>
                    <SarasGridItem xs={12} sm={12} md={12}>
                        <FormROValue formObject={formObject} rowKey={rowKey} action={{ paramName: "projectType2" }} className="uiUnHighlight"/>
                        <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "profile" }} className='uiUnHighlight uiSpacerL5 uiBlue uiSpacerL5' />
                    </SarasGridItem>
                </SarasGridContainer>
            </div>
        </FormLink>
    );
}

export default ProdSearchGridHeader
